export const tabOptions = [
  {
    label: 'Table View',
    value: 'table',
  },
  {
    label: 'Graph View',
    value: 'graph',
  },
];
